var _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96px",
    height: "320px",
    viewBox: "-1 -1 6 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "colon",
    style: {
      fillRule: "evenodd",
      stroke: "#FFFFFF",
      strokeWidth: 0.25,
      strokeOpacity: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "p1",
    cx: 2,
    cy: 7,
    r: 1,
    strokeWidth: 0,
    fill: "#FF0000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "p2",
    cx: 2,
    cy: 13,
    r: 1,
    strokeWidth: 0,
    fill: "#FF0000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColon);
export default __webpack_public_path__ + "static/media/colon.5f441c0da7c8dc07e70aba2ea8505d15.svg";
export { ForwardRef as ReactComponent };